define('helpers/HandlebarsHelper', [
  'specific/partials/playervideo'
], function(playervideo){

    var global = {};
    var trad = {};

    var initialize = function(options) {
        global = options.config;
        trad = options.trad;
    };

    Handlebars.registerHelper('global', function(key) {
        return global[key] || "";
    });

    Handlebars.registerHelper('log', function(arg) {
        console.log(arg);
    });

    Handlebars.registerHelper('i18n', function() {
        var key = arguments[0];
        var l = arguments.length;
        var s = trad[key];

        if( s && l > 2 ) {
            for( var i = 1; i < l - 1; i++ ) {
                s = s.replace( ('{{' + i + '}}'), arguments[i] );
            }
        }

        return s || ("TODO : " + key);
    });

    Handlebars.registerHelper('ifEquals', function(v1, v2, options) {
        if (v1 == v2) {
            return options.fn(this);
        } else {
            return options.inverse(this);
        }
    });

    Handlebars.registerHelper('ifCond', function(v1, operator, v2, options) {
       var bool;

       switch (operator) {
           case "==":
               bool = (v1==v2)?options.fn(this):options.inverse(this);
               break;
           case "!=":
               bool = (v1!=v2)?options.fn(this):options.inverse(this);
               break;
           case "===":
               bool = (v1===v2)?options.fn(this):options.inverse(this);
               break;
           case "!==":
               bool = (v1!==v2)?options.fn(this):options.inverse(this);
               break;
           case "&&":
               bool = (v1&&v2)?options.fn(this):options.inverse(this);
               break;
           case "||":
               bool = (v1||v2)?options.fn(this):options.inverse(this);
               break;
           case "<":
               bool = (v1<v2)?options.fn(this):options.inverse(this);
               break;
           case "<=":
               bool = (v1<=v2)?options.fn(this):options.inverse(this);
               break;
           case ">":
               bool = (v1>v2)?options.fn(this):options.inverse(this);
               break;
           case ">=":
               bool = (v1>=v2)?options.fn(this):options.inverse(this);
               break;
       }

       return bool;
   });

    Handlebars.registerPartial('playerVideo', playervideo);

    return {
        initialize: initialize
    };
});
